import { DatePipe } from '@angular/common';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { lowerCase, upperCase, upperFirst } from 'lodash';
import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';

@Component({
  selector: 'app-generic-partner-transaction-details',
  templateUrl: './generic-partner-transaction-details.component.html',
  styleUrls: ['./generic-partner-transaction-details.component.scss'],
})
export class GenericPartnerTransactionDetailsComponent
  extends ListingBaseComponent
  implements OnInit
{
  public user: any;
  CONFIG_?: string;

  WALLETS?: {
    walletName?: string;
    amount?: any;
    currency?: string;
  };

  details?: any;
  status?: string;
  partner?: string;

  sendDate?: any;
  statusDate?: any;

  beneficiary?: string;
  merchant?: string;
  address?: string;
  transaction?: {
    sender_receiver_relationship: string;
    cash_out_partner_name: string | undefined;
    cash_out_source_type: string | undefined;
    purpose: string;
    merchant?: any;
  };

  STATUS_HISTORY?: any[] = [];

  constructor(
    injector: Injector,
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<GenericPartnerTransactionDetailsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { selectedUser: string; data: any },
  ) {
    super(injector);

    this.user = this.userService.user;
    const partner = this.user.partner;
    this.partner = lowerCase(partner.name);

    this.CONFIG_ = partner?.config?.cms?.funds;
  }

  ngOnInit(): void {
    if (!!this.data) {
      this.transaction = this.details?.transaction_object;

      this.details =
        this.data?.selectedUser === undefined
          ? this.data?.data
          : this.data?.selectedUser;

      this.WALLETS = {
        walletName: this.details?.wallet_type?.name
          ? this.details?.wallet_type?.name
          : this.details.wallet_type,
        amount: Number(this.details?.amount1).toFixed(2),
        currency: this.details?.currency,
      };

      this.status = upperFirst(this.details.status);

      this.sendDate = this.datePipe.transform(
        this.details?.datetime_created,
        'medium',
      );

      this.statusDate = this.datePipe.transform(
        this.details?.datetime_updated,
        'medium',
      );

      this.getBeneficiary();
      this.getMerchantDetails();
      this.getStatusHistory();
    }
  }

  getBeneficiary() {
    if (this.details?.type === 'CASH_OUT' || this.details?.type === 'PAYMENT') {
      this.beneficiary = upperCase(
        this.details?.transaction_object?.app_user?.first_name +
          ' ' +
          this.details?.transaction_object?.app_user?.last_name,
      );
    } else {
      if (this.details?.merchant) {
        this.beneficiary = this.details?.merchant;
      } else {
        this.beneficiary = upperCase(
          this.details?.transaction_object?.receiver?.app_user
            ? this.details?.transaction_object?.receiver?.app_user
                ?.first_name_en +
                ' ' +
                this.details?.transaction_object?.receiver?.app_user
                  ?.last_name_en
            : this.details?.transaction_object?.receiver?.first_name +
                ' ' +
                this.details?.transaction_object?.receiver?.last_name,
        );
      }
    }
  }

  getMerchantDetails() {
    if (this.details?.type === 'PAYMENT') {
      this.merchant = this.details?.transaction_object?.merchant?.name;
      this.address = this.details?.transaction_object?.merchant?.address;
    } else if (this.details?.type === 'CASH_OUT') {
      this.merchant = this.details?.transaction_object
        ?.final_cash_out_branch_name
        ? this.details?.transaction_object?.final_cash_out_branch_name
        : this.details?.transaction_object?.selected_cash_out_branch_name;
      this.address = this.details?.transaction_object
        ?.final_cash_out_branch_address
        ? this.details?.transaction_object?.final_cash_out_branch_address
        : this.details?.transaction_object?.selected_cash_out_branch_address;
    }
  }

  getStatusHistory() {
    this.STATUS_HISTORY = this.details?.transaction_object?.status_history;
  }

  close() {
    this.dialogRef.close();
  }
}
